import React from "react";
import { PhoneFilled, CaretRightOutlined } from "@ant-design/icons";

const CurrentClasses = () => {
  return (
    <div className='class-container'>
      <div className='class-top-container'>
        {/* Previous alerts commented out */}
        {/* <div style={{ textAlign: "left" }} className='classes-alert'>
          Due To Covid-19 all classes will be conducted through the phone
        </div> */}

        {/* <div style={{ textAlign: "left" }} className='announcement-dec'>
          In sha Allah all classes with Aalima Nikhat Haider Aapa will resume from Monday,
          1st June 2020
        </div> */}
      </div>

      {/* Contact */}
      <div className='announcements-contact-container extra'>
        <div className='announcements-contact-title'>
          Classes will be on phone only <PhoneFilled />
        </div>

        <div className='announcements-contact-info'>
          <span><u>Phone Numbers:</u></span> 630-276-9453 OR 858-356-7294
        </div>

        <div className='announcements-contact-info'>
          <span><u>Conference Dial in:</u></span> 1 (978) 990-5000#
        </div>

        <div className='announcements-contact-info'>
          <span><u>Alternate Dial:</u></span> 1 (319) 527-3163
        </div>

        <div className='announcements-contact-info'>
          <span><u>Access code:</u></span> 862551#
        </div>
      </div>

      <div className='class-main-container'>

        {/* ============================
            ALL PREVIOUS CLASSES REMOVED
            (COMMENTED OUT FOR REFERENCE)
        ============================= */}

        {/* 
        <div className='class-container-style'> ... </div>
        <div className='class-container-style'> ... </div>
        <div className='class-container-style'> ... </div>
        */}

        {/* ============================
            NEW UPDATED CLASS ADDED
        ============================= */}

        <div className='class-container-style'>
          <h1 className='classes-name'>
            <span className='right-carrot'><CaretRightOutlined /></span>
            1000 Sunnatain (Part 13) — Namaz Ke Baad Ki Qauli Sunnatain (Part 5)
            <span className='date-occurrence'>
              (Monday, 17th November 2025)
            </span>
          </h1>

          <div className='class-sub-text-container'>

            <div className='class-decription-container'>
              <div>
                <span className='class-description-title'>Speaker:</span>
                <span className='class-decription-text'>Alima Nikhat Haider</span>
              </div>
            </div>

            <div className='class-decription-container'>
              <div>
                <span className='class-description-title'>Class Timings:</span>
                <span className='class-decription-text'>11:00 am - 12:30 pm (US Central)</span>
              </div>
            </div>

            <div className='class-decription-container'>
              <div>
                <span className='class-description-title'>Class Attendance:</span>
                <span className='class-decription-text'>Join Through Phone Only</span>
              </div>
            </div>

            <div className='class-decription-container'>
              <div>
                <span className='class-description-title'>Streaming:</span>
                <span className='class-decription-text'>Live on YouTube & Facebook</span>
              </div>
            </div>

            <div className='class-decription-container'>
              <div>
                <span className='class-description-title'>Website:</span>
                <span className='class-decription-location'>www.sakeenat.org</span>
              </div>
            </div>

          </div>

          <hr className='event-line' />
        </div>

      </div>
    </div>
  );
};

export default CurrentClasses;
